// import { ZuAuthStore } from "@hooks/stores/zustand-auth-store";
import { Outlet } from "react-router-dom";

const PublicRoute = () => {
  // const { customer } = ZuAuthStore();

  // If not logged, redirect to Dashboard
  // Or, render the public route (without layout)

  // Force to Dashboard when logged
  // return customer ? <Navigate to="/dashboard" replace /> : <Outlet />;

  // Allows to see Landing Page logged
  return <Outlet />;
};

export default PublicRoute;
